import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=2b3d8a0e&scoped=true&"
import script from "./Store.vue?vue&type=script&lang=js&"
export * from "./Store.vue?vue&type=script&lang=js&"
import style0 from "./Store.vue?vue&type=style&index=0&id=2b3d8a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d8a0e",
  null
  
)

export default component.exports